import React from "react";
import style from "./keyboard.module.scss";

function KeyboardComp({ key, icon }) {
  return (
    <div className={style["keyboard-comp"]}>
      <span className={style["key-text"]}>⌘</span>
      <span className={style["key-text"]}>K</span>
    </div>
  );
}

export default KeyboardComp;
